
import Cta from '@/components/ui/cta.vue';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'HeroAlternative',

  components: {
    Cta,
    WpImage,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      defaultColors: {
        textColorHeading: '#ffffff',
        textColorText: '#ffffff',
        textColorTextMobile: '#000000',
        shadowColor: '#000000',
        buttonColor: '#000000',
      },
    };
  },

  computed: {
    heroColumns() {
      const cols = this.data?.hero_columns;
      return Array.isArray(cols) ? cols : [];
    },
    isMobileViewport() {
      return typeof window !== 'undefined' && window.innerWidth < 720;
    },
    hasAnyBadge() {
      return this.heroColumns.some((c) => !!c?.item_badge);
    },
    hasAnyImage() {
      return this.heroColumns.some((c) => !!c?.image || !!c?.image_mobile);
    },
  },

  methods: {
    getHeadingTag(column) {
      const level = column && column.heading_level;
      const allowed = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
      return allowed.includes(level) ? level : 'h1';
    },
    getIsMobile(column) {
      return this.isMobileViewport && column.image_mobile;
    },
    getImageObject(column) {
      if (!column) return null;
      return this.getIsMobile(column)
        ? column.image_mobile
        : column.image || null;
    },
    setSpecificColor(colorMobile, colorDesktop, defaultColor) {
      const colorValue = this.isMobileViewport ? colorMobile : colorDesktop;
      return colorValue && colorValue.length > 0 ? colorValue : defaultColor;
    },
    getColors(column) {
      return {
        textColorHeading: column?.text_color_desktop
          ? column?.text_color_desktop
          : this.defaultColors.textColorHeading,
        textColorText: this.isMobileViewport
          ? this.setSpecificColor(
              column?.text_color_mobile,
              column?.text_color_desktop,
              this.defaultColors.textColorTextMobile
            )
          : this.setSpecificColor(
              column?.text_color_mobile,
              column?.text_color_desktop,
              this.defaultColors.textColorText
            ),
        shadowColor: this.setSpecificColor(
          column?.shadow_color_mobile,
          column?.shadow_color_desktop,
          this.defaultColors.shadowColor
        ),
        buttonColor: this.setSpecificColor(
          column?.button_color_mobile,
          column?.button_color_desktop,
          this.defaultColors.buttonColor
        ),
      };
    },
  },
};
